import { createBundle } from 'widget/Common';
import MaterialShareView from 'bundle-loader?lazy&name=MaterialShareView!pages/Share/MaterialShare/MaterialShareView';
import BirthdayVideoView from 'bundle-loader?lazy&name=BirthdayVideoView!pages/Share/BirthdayVideo/BirthdayVideoView';
import ExpertCard from 'bundle-loader?lazy&name=ExpertCardView!pages/Share/ExpertCard/ExpertCardView';

const RouterConfig = [
  {
    path: '/share/materialShare',
    title: '素材分享',
    component: () => {
      return createBundle(MaterialShareView);
    }
  },
  {
    path: '/share/birthdayVideo',
    title: '生日分享',
    component: () => {
      return createBundle(BirthdayVideoView);
    }
  },
  {
    path: '/share/expertCard',
    title: '产品专家',
    component: () => {
      return createBundle(ExpertCard);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Share/RouterConfig.js